import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const RecieveMoneyRightContainer = styled.div`
  height: 434px;
  width: 625px;
  /* width: 50%; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  /* background-color: red; */

  @media screen and (max-width: 1024px) {
    gap: 0px;
  }
  @media screen and (max-width: 768px) {
    width: 568px;
    height: 314px;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    /* width: 327px; */
    height: 342px;
    padding-left: 50px;
    box-sizing: border-box;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    height: 342px;
    padding-left: 30px;
  }
  @media screen and (max-width: 320px) {
    width: 327px;
    height: 342px;
    margin-left: 0px;
  }
`;

export const RecieveMoneyRightTextHolder = styled.div`
  width: 625px;
  height: 296px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 1024px) {
    width: 100%;
    margin-top: 20px;
    /* height: 314px; */
  }
  @media screen and (max-width: 768px) {
    width: 568px;
    margin-bottom: 20px;
    /* height: 314px; */
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    margin-bottom: 20px;
    /* height: 342px; */
    /* background: var(--General-Background, #f7f7f7);
    padding-left: 5px; */
  }
  @media screen and (max-width: 375px) {
    margin-bottom: 20px;
    width: 100%;
    /* height: 342px; */
    /* background: var(--General-Background, #f7f7f7);
    padding-left: 5px; */
  }
`;

export const TitleText = styled.div`
  width: 100%;
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.heading1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
`;

export const SubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;
